export const buildMapFromBatch = <T extends { id: number }>(obj: {
  [id: number]: T;
}): Map<any, any> => {
  const map = new Map();
  Object.keys(obj).forEach(key => obj[key] && map.set(parseInt(key), obj[key]));
  return map;
};
